export default "__VITE_ASSET__B8HJ9ki$__"